import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type CloseEyeIconProps = {
    color?: string
    width?: number
    height?: number
    className?: ClassName
    style?: React.CSSProperties
}

export function CloseEyeIcon({
    className,
    style,
    width = 25,
    height = 19,
    color = '#535353',
}: CloseEyeIconProps): React.ReactElement {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
            data-testid="CloseEyeIcon"
        >
            <g clipPath="url(#clip0_1340_4076)">
                <path
                    d="M8.016 10.073c0 2.348 1.976 4.264 4.414 4.264 2.438 0 4.415-1.909 4.415-4.264 0-2.356-1.983-4.264-4.415-4.264-2.431 0-4.414 1.915-4.414 4.264Zm7.876 0c0 1.848-1.556 3.35-3.469 3.35-1.913 0-3.468-1.502-3.468-3.35s1.555-3.344 3.468-3.344 3.469 1.503 3.469 3.344Z"
                    fill={color}
                />
                <path
                    d="M24.629 9.795c-.126-.162-1.976-2.43-4.814-4.304l-.616.724a22.811 22.811 0 0 1 4.442 3.864c-1.086 1.24-5.753 6.166-11.218 6.166S2.291 11.311 1.205 10.073c1.086-1.239 5.753-6.166 11.218-6.166 1.899 0 3.693.602 5.283 1.428l.624-.73C16.592 3.676 14.58 3 12.423 3 5.74 3 .448 9.518.224 9.795L0 10.073l.224.277c.224.278 5.515 6.795 12.2 6.795 6.684 0 11.98-6.517 12.198-6.795l.224-.277-.217-.278Z"
                    fill={color}
                />
                <path d="M3.646 18.646 21.218 1.075" stroke={color} />
            </g>
        </svg>
    )
}
